import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js'
function PharmInvoiceOther(props) {
    const {sale_pharm} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'pharm-invoice-other/' + sale_pharm)
                .then(function (response) {
                    setopbillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        if (opbillData.length > 0) {
            fetchPharmData();
        }
    }, [opbillData]);
    function fetchPharmData() {
        const ipIds = opbillData.map(row => row.product.split(',').map(item => item.trim()));
        ipIds.forEach(ipId => {
            try {
                ipId.forEach(id => {
                    axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
                        .then(function (response) {
                            const data = Object.assign({}, response.data);
                            setViewPharmData(prevData => [...prevData, data]);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                });
            } catch (error) {
                console.log(error);
            }
        });
    }
    const handlePrint = () => {
        const printContents = document.getElementById("invoice-print").innerHTML;
        const printStyles = `
        <style>
            * {
                box-sizing: border-box;
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
            }

            html,
            body {
                margin: 0 !important;
                padding: 0 !important;
                width: 100% !important;
                background: #fff !important;
                color: #000 !important;
                line-height: 1.35 !important;
            }

            /* =========================================
               PRINT PAGE
               ========================================= */

            .pharmacy-print-page {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 auto !important;
                padding: 0.20in !important;
            }

            /* =========================================
               HOSPITAL HEADER (NO BORDERS)
               ========================================= */

            .pharmacy-print-page .hospital-responsive-table,
            .pharmacy-print-page .hospital-responsive-table tr,
            .pharmacy-print-page .hospital-responsive-table td,
            .pharmacy-print-page .hospital-responsive-table th {
                border: none !important;
                background: transparent !important;
            }

            .pharmacy-print-page .hospital-responsive-table {
                width: 100% !important;
                border-collapse: collapse !important;
            }

            .pharmacy-print-page .hospital-details-cell {
                width: 100% !important;
                padding: 5px 8px !important;
                text-align: center !important;
                vertical-align: middle !important;
                border: none !important;
            }

            .pharmacy-print-page .hospital-logo-container {
                float: left !important;
                text-align: left !important;
            }

            .pharmacy-print-page .hospital-logo {
                width: 120px !important;
                height: 120px !important;
                object-fit: contain !important;
                display: block !important;
            }

            .pharmacy-print-page .hospital-text-container {
                display: inline-block !important;
                text-align: left !important;
            }

            .pharmacy-print-page .hospital-name {
                text-align: left !important;
                font-size: 18px !important;
                font-weight: bold !important;
                line-height: 1.2 !important;
                margin: 0 !important;
                padding: 0 !important;
            }

            .pharmacy-print-page .hospital-detail-line {
                text-align: left !important;
                font-size: 11px !important;
                line-height: 1.3 !important;
                margin: 0 !important;
                padding: 0 !important;
            }

            /* =========================================
               ALL BORDERED TABLES (PATIENT & MEDICINE TABLES)
               ========================================= */

            .print-bordered-table {
                width: 100% !important;
                max-width: 100% !important;
                border-collapse: collapse !important;
                border-spacing: 0 !important;
                table-layout: fixed !important;
                empty-cells: show !important;
                border: 1px solid #000 !important;
            }

            .print-bordered-table tr,
            .print-bordered-table th,
            .print-bordered-table td {
                border: 1px solid #000 !important;
            }

            .print-bordered-table th,
            .print-bordered-table td {
                padding: 4px !important;
                font-weight: bold !important;
                vertical-align: top !important;
            }

            .print-bordered-table th {
                background: #eee !important;
            }

            /* =========================================
               PATIENT INFORMATION CELLS
               ========================================= */

            .patient-info-cell {
                width: 60% !important;
                vertical-align: top !important;
                text-align: left !important;
                white-space: nowrap !important;
                line-height: 1.3 !important;
                border: 1px solid #000 !important;
            }

            .patient-info-cell > div {
                white-space: nowrap !important;
            }

            .consultant-line {
                white-space: nowrap !important;
            }

            .invoice-info-cell {
                width: 40% !important;
                vertical-align: top !important;
                text-align: left !important;
                white-space: nowrap !important;
                line-height: 1.3 !important;
                border: 1px solid #000 !important;
            }

            /* =========================================
               AMOUNT
               ========================================= */

            .paid-amount {
                font-weight: bold !important;
                white-space: nowrap !important;
            }

            /* =========================================
               FOOTER
               ========================================= */

            .cash-received-section {
                width: 100% !important;
                display: flex !important;
                flex-direction: row !important;
                align-items: flex-end !important;
                justify-content: space-between !important;
                margin-top: 25px !important;
                padding: 5px 10px !important;
                border: 0 !important;
                box-sizing: border-box !important;
            }

            .cash-received-section .pharmacist-user {
                flex: 1 1 33.33% !important;
                width: 33.33% !important;
                text-align: left !important;
                font-weight: bold !important;
                font-size: 11pt !important;
                white-space: nowrap !important;
            }

            .cash-received-section .pharmacist-signature {
                flex: 1 1 33.33% !important;
                width: 33.33% !important;
                text-align: center !important;
                font-weight: bold !important;
                font-size: 11pt !important;
                white-space: nowrap !important;
            }

            .cash-received-section .cash-received {
                flex: 1 1 33.33% !important;
                width: 33.33% !important;
                text-align: right !important;
                font-weight: bold !important;
                font-size: 10pt !important;
                white-space: nowrap !important;
            }

            /* =========================================
               PRINT MEDIA FIXES
               ========================================= */

            @page {
                size: auto;
                margin: 5mm;
            }

            @media print {
                html,
                body {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                }

                .print-bordered-table {
                    border-collapse: collapse !important;
                    border-spacing: 0 !important;
                    border: 1px solid #000 !important;
                }

                .print-bordered-table th,
                .print-bordered-table td {
                    border: 1px solid #000 !important;
                }

                .hospital-responsive-table {
                    display: table !important;
                    width: 100% !important;
                    border: none !important;
                }
            }
        </style>
    `;
        const printWindow = window.open("", "", "height=800,width=800");
        printWindow.document.write(`
        <html>
            <head>
                <title>Invoice</title>
                ${printStyles}
            </head>
            <body>
                ${printContents}
            </body>
        </html>
    `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            setTimeout(() => {
                printWindow.close();
            }, 500);
        }, 300);
    };
    const isNumeric = (value) => {
        return /^\d+$/.test(value);
    };
    function numberToWords(num) {
        const units = [
            'zero',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine'
        ];
        const teens = [
            'ten',
            'eleven',
            'twelve',
            'thirteen',
            'fourteen',
            'fifteen',
            'sixteen',
            'seventeen',
            'eighteen',
            'nineteen'
        ];
        const tens = [
            '',
            '',
            'twenty',
            'thirty',
            'forty',
            'fifty',
            'sixty',
            'seventy',
            'eighty',
            'ninety'
        ];
        function convertBelowThousand(n) {
            let result = '';
            if (n >= 100) {
                result += units[Math.floor(n / 100)] + ' hundred';
                n = n % 100;
                if (n > 0) {
                    result += ' and ';
                }
            }
            if (n >= 20) {
                result += tens[Math.floor(n / 10)];
                if (n % 10 !== 0) {
                    result += '-' + units[n % 10];
                }
                return result;
            }
            if (n >= 10) {
                result += teens[n - 10];
                return result;
            }
            if (n > 0) {
                result += units[n];
            }
            return result;
        }
        num = Math.round(Number(num) || 0);
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) {
            return 'negative ' + numberToWords(Math.abs(num));
        }
        const scales = [
            '',
            'thousand',
            'lakh',
            'crore'
        ];
        let result = '';
        const crore = Math.floor(num / 10000000);
        num = num % 10000000;
        const lakh = Math.floor(num / 100000);
        num = num % 100000;
        const thousand = Math.floor(num / 1000);
        num = num % 1000;
        if (crore > 0) {
            result += convertBelowThousand(crore) + ' crore ';
        }
        if (lakh > 0) {
            result += convertBelowThousand(lakh) + ' lakh ';
        }
        if (thousand > 0) {
            result += convertBelowThousand(thousand) + ' thousand ';
        }
        if (num > 0) {
            result += convertBelowThousand(num);
        }
        return result.trim() + ' rupees only';
    }
    return (
        <section className="pharmacy-print-page">
            <div>
                {opbillData.map((row, index) =>
                    <div id="invoice-print">
                        <div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>
                        <table
                            border="1"
                            cellPadding="4"
                            className="text-justify mt-1"
                            style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #000'}}
                        >
                            <tbody>
                            <tr>
                                <td className="patient-info-cell" style={{
                                    width: '60%',
                                    border: '1px solid #000',
                                    verticalAlign: 'top',
                                    padding: '6px'
                                }}>
                                    <div><strong>Name
                                        :</strong> {isNumeric(row?.patient) ? row?.pat?.patient : row?.patient}</div>
                                    <div><strong>PID :</strong> {row.pat?.pat_id}</div>
                                    <div><strong>Age/Gender :</strong> {row.pat?.age}/{row.pat?.gender}</div>
                                    <div className="consultant-line">
                                        <strong>Consultant
                                            :</strong> Dr.{row.cons?.consultant} {row.cons?.specialization}
                                    </div>
                                </td>
              <td
    className="invoice-info-cell"
    style={{
        width: '40%',
        border: '1px solid #000',
        verticalAlign: 'top',
        padding: '6px'
    }}
>
    {hospData.map((hospital) => (
        <React.Fragment key={hospital.id}>
            {hospital.gst && (
                <div>
                    <strong>GST :</strong> {hospital.gst}
                </div>
            )}

            {hospital.dl && (
                <div>
                    <strong>DL :</strong> {hospital.dl}
                </div>
            )}
        </React.Fragment>
    ))}

    <div>
        <strong>Invoice No #:</strong> {row.sale_id}
    </div>

    <div>
        <strong>Date/Time :</strong> {row.add_date} {row.add_time?.split('.')[0]}
    </div>

    <div>
        <strong>
            {row.mode
                ? row.mode.charAt(0).toUpperCase() + row.mode.slice(1)
                : ''} Receipt
        </strong>
    </div>
</td>
                            </tr>
                            </tbody>
                        </table>
                        <div className="table-responsive">
                            <table border="2" rules="rows" cellpadding="3" className="text-justify mt-4" width="100%">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th align="left">S.No</th>
                                    <th align="left">HSN</th>
                                    <th align="left">Product</th>
                                    <th align="left">Packs</th>
                                    <th align="left">Batch No</th>
                                    <th align="left">Expiry Date</th>

                                    <th align="left">MRP</th>
                                    <th align="left">Qty</th>
                                    <th align="left">CGST%</th>
                                    <th align="left">SGST%</th>
                                    <th align="left">Net Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {row.product.split(',').map((test, subIndex) => {
                                    const pharmData = viewPharmData.find((data) => data.id == test);
                                    return (
                                        <tr key={`${index}-${subIndex}`}
                                            style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <td><b>{index + subIndex + 1}</b></td>
                                            <td><b>{pharmData?.product.hsn}</b></td>
                                            <td><b>{pharmData?.product.product}</b></td>
                                            <td><b>{pharmData?.product.pack}</b></td>
                                            <td><b>{pharmData?.product.batch}</b></td>
                                            <td><b>{pharmData?.product.expiry}</b></td>

                                            <td><b>Rs.{pharmData?.product.mrp}</b></td>
                                            <td><b>{row.qty.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{pharmData?.product.sgst}</b></td>
                                            <td><b>{pharmData?.product.cgst}</b></td>

                                            <td>
                                                <b>
                                                    Rs.
                                                    {parseFloat(row.netamount.split(',')[subIndex].trim()).toFixed(2)}
                                                </b>
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td align="center" colSpan="6"></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Invoiced
                                        Amount</b></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        <b>Rs.{row.total}</b></td>
                                </tr>
                                {row.disc != 0 && row.disc != "" && row.disc != null && (
                                    <tr>
                                        <td align="center" colSpan="6"></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Discount
                                            Amount</b></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <b style={{color: "red"}}>Rs.{row.disc}</b></td>
                                    </tr>
                                )}
                                <tr>
                                    <td align="center" colSpan="6"></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Paid
                                        Amount</b></td>
                                    <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                        <b className="paid-amount">
                                            Rs.{Math.round(Number(row.paid) || 0)}
                                        </b></td>
                                </tr>
                                {row.balance != 0 && row.balance != "" && (
                                    <tr>
                                        <td align="center" colSpan="6"></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Balance
                                            Amount</b></td>
                                        <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <b>Rs.{row.balance}</b></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                            <p className="mt-2 p-3 text-bold">Received the sum
                                of {numberToWords(parseFloat(row.paid))}.</p>
                            <div className="cash-received-section">

                                <div className="pharmacist-user">
                                    User: {row.addedby}
                                </div>

                                <div className="pharmacist-label">
                                    Pharmacist Signature
                                </div>

                                <div className="cash-received">
                                    Cash Received
                                </div>

                            </div>
                        </div>
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default PharmInvoiceOther;